<template>
  <app-layout :account-global-menu="accountGlobalMenu">
    <template #main-content>
      <main id="content" class="l-main p-account">
        <div class="l-main__inner">
          <div class="c-page-header">
            <h1 class="c-page-header-title">各種設定</h1>
            <button-return @click="goBack" name="S6-2-back-btn">戻る</button-return>
          </div>
          <section>
            <div class="c-parts-box">
              <div class="c-parts-box__inner">
                <section class="p-account-item" v-if="accountStore.isSouruby !== null">
                  <h2 class="p-account-item__title"><ruby>総<rt>そう</rt></ruby>ルビ<ruby>表示<rt>ひょうじ</rt></ruby>の<ruby>設定<rt>せってい</rt></ruby></h2>
                  <p class="p-account-item__text">ONにすると，すべての<ruby>漢字<rt>かんじ</rt></ruby>に「ふりがな」が<ruby>表示<rt>ひょうじ</rt></ruby>されます。</p>
                  <div
                    :class="{'c-parts-toggle':true,'c-parts-toggle--active': accountStore.isSouruby}"
                    @click="toggleSwitch('ruby')" name="S6-2-rubby-toggle-btn">
                    <span class="label">{{accountStore.isSouruby?'ON':'OFF'}}</span>
                    <span class="toggle"></span>
                  </div>
                </section>
                <section class="p-account-item">
                  <h2 class="p-account-item__title">リフレッシュ機能の設定</h2>
                  <p class="p-account-item__text">目などの健康のため、30分学習するごとに休憩をおすすめしています。<br>OFFにすると休憩をすすめる表示は出なくなります。</p>
                  <div
                    :class="{'c-parts-toggle':true,'c-parts-toggle--active': accountStore.isBreakTime}"
                    @click="toggleSwitch('break')" name="S6-2-refresh-time-toggle-btn">
                    <span class="label">{{accountStore.isBreakTime?'ON':'OFF'}}</span>
                    <span class="toggle"></span>
                  </div>
                </section>
                <section class="p-account-item">
                  <h2 class="p-account-item__title">効果音／BGMの設定</h2>
                  <p class="p-account-item__text">OFFにすると，各画面の効果音やBGMは再生されません。<br>※問題解説動画や英語のリスニング音声は再生されます。</p>
                  <div
                    :class="{'c-parts-toggle':true,'c-parts-toggle--active': accountStore.isSoundEnabled}"
                    @click="toggleSwitch('sound')" name="S6-2-bgm-toggle-btn">
                    <span class="label">{{accountStore.isSoundEnabled?'ON':'OFF'}}</span>
                    <span class="toggle"></span>
                  </div>
                </section>
                <section class="p-account-item">
                  <h2 class="p-account-item__title">音声読み上げボタンの表示</h2>
                  <p class="p-account-item__text">音声読み上げボタンを表示します。<br>OFFにすると音声読み上げボタンは出なくなります。</p>
                  <div
                    :class="{'c-parts-toggle':true,'c-parts-toggle--active': accountStore.isTtsEnabled}"
                    @click="toggleSwitch('text-to-speech')" name="S6-2-tts-toggle-btn">
                    <span class="label">{{accountStore.isTtsEnabled?'ON':'OFF'}}</span>
                    <span class="toggle"></span>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>
      </main>
    </template>
  </app-layout>
</template>

<script setup lang="ts">
  import {ref, onMounted} from "vue";
  import {useRouter} from "vue-router";
  import { useAccountStore } from '@/store/student/account_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';

  const accountGlobalMenu = ref(true)
  const processing = ref(false)
  const accountStore = useAccountStore()
  const router = useRouter()

  onMounted(() => {
    document.title = "各種設定"
    useGlobalNavigationStore().saveSelectedMenu("acReader")
  })
  function goBack(){
    router.go(-1)
  }
  async function toggleSwitch(settingType: string){
    // APIレスポンスが来る前はトグル操作を防ぐためprocessing変数を設定
    if(processing.value){
      return
    }
    try {
      processing.value = true;

      // 総ルビ表示の設定
      if (settingType === 'ruby') {
        const toggleValue = !accountStore.isSouruby;
        await accountStore.fetchUpdateSettings({ "settings": { "souruby_enabled": toggleValue } });
        accountStore.saveRubySetting(toggleValue);
      // リフレッシュ機能の設定
      } else if (settingType === 'break') {
        const toggleValue = !accountStore.isBreakTime;
        await accountStore.fetchUpdateSettings({ "settings": { "is_break_time": toggleValue } });
        accountStore.saveBreakTimeSetting(toggleValue);
      } else if(settingType === 'sound') {
        const toggleValue = !accountStore.isSoundEnabled;
        await accountStore.fetchUpdateSettings({ "settings": { "is_sound_enabled": toggleValue}});
        accountStore.saveSoundEnabledSetting(toggleValue);
      } else if(settingType === 'text-to-speech') {
        const toggleValue = !accountStore.isTtsEnabled;
        await accountStore.fetchUpdateSettings({ "settings": { "is_tts_enabled": toggleValue}});
        accountStore.saveTtsEnabledSettings(toggleValue);
      }
    } catch (error) {
      console.log("error: ", error)
    } finally {
      processing.value = false;
    }
  }
</script>
